module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-search-vehicle-availability"
  }, [_c('h2', [_vm._v("Availability")]), (_vm.availability.length) ? _c('backoffice-vehicle-availability', {
    attrs: {
      "availability": _vm.availability,
      "selectable": _vm.selectable
    },
    on: {
      "update:availability": function($event) {
        _vm.availability = $event
      },
      "slotsSelected": _vm.slotSelected,
      "loadExtra": _vm.showExtraDay
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74b26d10!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/SearchVehicleAvailability.vue
// module id = 2605
// module chunks = 1